import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { BolinhaIndicador } from './models/bolinha-indicador.model';
import { ESCALA_BOLINHA_BORDA } from './utils/indicador-paginas.constantes';

@Component({
  selector: 'app-indicador-paginas',
  standalone: true,
  templateUrl: './indicador-paginas.component.html',
  styleUrl: './indicador-paginas.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndicadorPaginasComponent {
  readonly total = input.required<number>();
  readonly posicao = input(0);
  readonly tamanho = input(8);
  readonly larguraAtiva = input(20);
  readonly espaco = input(6);
  readonly maxVisiveis = input(7);
  readonly ocultarComUmItem = input(true);
  readonly rotulo = input('Ir para o item');
  readonly selecionar = output<number>();

  readonly ativo = computed(() => Math.round(this.posicao()));

  readonly bolinhas = computed<BolinhaIndicador[]>(() => {
    const posicao = this.posicao();
    const total = Math.max(0, this.total());
    const maximo = Math.max(3, this.maxVisiveis());
    const extra = Math.max(0, this.larguraAtiva() - this.tamanho());
    const inicio = total <= maximo ? 0 : Math.min(Math.max(0, this.ativo() - Math.floor(maximo / 2)), total - maximo);
    const fim = Math.min(total, inicio + maximo);
    return Array.from({ length: fim - inicio }, (_, deslocamento) => {
      const indice = inicio + deslocamento;
      const borda = (indice === inicio && inicio > 0) || (indice === fim - 1 && fim < total);
      const escala = borda ? ESCALA_BOLINHA_BORDA : 1;
      const destaque = Math.max(0, 1 - Math.abs(posicao - indice));
      return { indice, destaque, largura: (this.tamanho() + extra * destaque) * escala, altura: this.tamanho() * escala };
    });
  });
}
